module.exports = __webpack_public_path__ + "static/media/mytransaction.0914bdb2.svg";